import authInstance from "../Interceptor/interceptor";

export const addPatientEffect = (formData) => {
  return authInstance.post("/patients/insert", formData);
};

export const deletePatientEffect = (id) => {
  return authInstance.delete(`/patients/deletePatient/${id}`);
};

export const editPatientEffect = (id, formData) => {
  return authInstance.put(`/patients/updatepatient/${id}`, formData);
};
export const ViewPatientEffect = (patientId) => {
  return authInstance.get(`/patients/getpatient?patient_id=${patientId}`);
};
export const listPatientEffect = (pageNo) => {
  return authInstance.get(
    `/patients/list?pageNo=${pageNo}&pagesize=15&pagination_required=true`
  );
};
export const listPatient = () => {
  return authInstance.get(`/patients/list`);
};
export const historyPatientEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search, search_by } = payload;
  return authInstance.get(
    `/attenderbooking/getbysecirity?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search_by=${search_by}&search=${search}`
  );
};
